import { Routes, Route } from "react-router-dom";
import Error404 from "./components/common/error404";
import ChallengeIndex from "./pages/challenge";
import FundIndex from "./pages/funds";
import ProposalIndex from "./pages/proposal";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ProposersIndex from "./pages/proposer";
import SingleProposerIndex from "./pages/proposer/SingleProposerIndex";
import ProposalsInChallengeIndex from "./pages/proposal/proposalsInChallengeIndex";
import ProposalDetailIndex from "./pages/proposal/proposalDetailIndex";
import HomeIndex from "./pages/index";
import AnalyticsPanel from "./pages/analytics/index";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/error/ErrorHandler";
import APIDocuments from "./pages/documentation";
import SpreadsheetResources from "./pages/documentation/spreadsheetResources";
import Dashboard from "./pages/github";

const theme = createTheme({
  palette: {
    primary: {
      main: "#607d8b",
      dark: "#37474f",
      light: "#eceff1",
    },
    secondary: {
      main: "#C19E66",
      dark: "#736742",
      light: "#E8DFC5",
    },
    text: {
      primary: "#37474f",
      secondary: "#90a4ae",
    },
  },
  typography: {
    // fontFamily: 'Lato',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightBold: 700,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
        <Routes>
          <Route path="/" element={<HomeIndex />}></Route>
          <Route path="/funds" element={<FundIndex />}></Route>
          <Route path="/challenges" element={<ChallengeIndex />}></Route>
          <Route
            path="/fund/:fundid/challenges"
            element={<ChallengeIndex />}
          ></Route>
          <Route path="/proposals" element={<ProposalIndex />}></Route>
          <Route
            path="/proposal/:proposalid"
            element={<ProposalDetailIndex />}
          ></Route>
          <Route
            path="/challenge/:challengeid"
            element={<ProposalsInChallengeIndex />}
          ></Route>
          <Route path="/proposers" element={<ProposersIndex />}></Route>
          <Route
            path="/proposer/:userid"
            element={<SingleProposerIndex />}
          ></Route>
          <Route path="/analytics" element={<AnalyticsPanel />} />
          <Route path="/apiDocuments" element={<APIDocuments />} />
          <Route path="/collaborators" element={<Error404 />} />
          <Route path="/resources/:type" element={<SpreadsheetResources />} />
          <Route path="/github" element={<Dashboard />} />
          <Route path="/github/cardano" element={<Dashboard />} />
          <Route path="/github/quai" element={<Dashboard type="quai" />} />

          <Route path="*" element={<Error404 />}></Route>
        </Routes>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
